<div class="header-user-container">
  <div class="user flex items-center">
    <span class="user-name">{{ user().name }}</span>
    <app-user-level [level]="user().level"></app-user-level>
  </div>
  <div class="exp flex items-center">
    <number-flow class="exp-current" #currExpNumberFlow></number-flow>
    <span class="separator">/</span>
    <number-flow class="exp-next" #nextExpNumberFlow></number-flow>
    <span class="xp-label">XP</span>
  </div>
  <app-player-avatar class="avatar" [user]="user()"></app-player-avatar>
</div>
